const bodyClasses = {
  header: {
    short: 'body__header--short', // "small" logo & header - document scrolled
    transitioning: 'body__header--transitioning'
  },
  buyTix: {
    open: 'body__buy-tix--open',
    closing: 'body__buy-tix--closing'
  },
  navMain: {
    open: 'body__nav-main--open',
    closing: 'body__nav-main--closing'
  }
};

export default bodyClasses;